import { Component, Input, OnInit } from '@angular/core';
import { ZoomMeeting } from 'lfx-pcc';
import { Observable } from 'rxjs';
import { NgIf } from '@angular/common';

@Component({
  selector: 'lfx-meeting-header',
  templateUrl: './meeting-header.component.html',
  styleUrls: ['./meeting-header.component.scss'],
  standalone: true,
  imports: [NgIf],
})
export class MeetingHeaderComponent implements OnInit {
  @Input() public meeting: ZoomMeeting;

  public logoURL$: Observable<string>;

  public constructor() {}

  public ngOnInit(): void {}
}
